import styled from 'styled-components';

export const ViewContainer = styled.div`
  margin-top: 20px;
  width: 500px;
`;

export const AddImageArea = styled.div<{
  shouldAjustHeight: boolean;
  shouldCenterItems: boolean;
}>`
  border-radius: 10px;
  width: 100%;
  padding: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: ${({ shouldCenterItems }) =>
    shouldCenterItems ? 'center' : ''};
  height: ${({ shouldAjustHeight }) =>
    shouldAjustHeight ? 'max-content' : '60px'};
  cursor: pointer;
`;

export const AddImageAreaText = styled.div`
  color: #ff6a00;
  font-family: Space Grotesk;
  font-weight: 500;
`;

export const FilePreviewContainer = styled.div`
  position: relative;
  width: fit-content;
`;
export const FilePreviewCloseIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-color: #f5f5f5;
  position: absolute;
  border-radius: 100%;
  right: -20px;
  top: -10px;
`;
